import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTensorflowComponent } from './simple-icons-tensorflow.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTensorflowComponent ],
    exports:      [ SimpleIconsTensorflowComponent ],
    bootstrap:    []
})
export class SimpleIconsTensorflowModule {}
